export default __webpack_public_path__ + "static/media/edit_black.fe50ce1d.svg";